import React, { createContext, useContext } from 'react';
import { LinkToDebrief, LinkToHome } from 'ff/debrief/router';

export type RouteContextType = {
    returnLink?: React.ElementType;
    debriefLink?: React.ElementType;
    page?:
        | 'DebriefView'
        | 'SharedWithMeView'
        | 'TrackListView'
        | 'SharedDebriefView'
        | 'AnonSharedView';
};

export const RouteContext = createContext<RouteContextType>({
    returnLink: LinkToHome,
    debriefLink: LinkToDebrief,
    page: 'TrackListView',
});

export const useRouteContext = () => useContext(RouteContext);
